<template>
<div class="content">
    <alert-component></alert-component>
    <div class="card fix-mobile-btgroup-bottom">
        <div class="card-header bg-white header-elements-inline">
            <div class="card-title">
                <h5 class="font-weight-semibold"><i class="fas fa-user mr-2"></i>{{$t('Edit Profile')}}</h5>
                <div>{{$t('We will contact you with this information.')}}</div>
            </div>
            <div class="header-elements">
                <button @click="confirmSave" :disabled="$v.validationGroup.$invalid" type="button" class="btn btn-primary"><i class="fas fa-save mr-2"></i>{{$t('_Profile.Save Changes')}}</button>
            </div>
        </div>
        <div class="card-body">
            <account-details-component @fetchData="fetchData($event)" v-if="showInfo" ref="accountDetails"></account-details-component>
        </div>
    </div>
    <div class="card">
        <div class="card-header bg-white">
            <div class="card-title">
                <h5 class="font-weight-semibold"><i class="fas fa-sign-in-alt mr-2"></i>{{$t('Login Service')}}</h5>
                <div>{{$t('Connect an external login service to quickly and securely access')}}</div>
            </div>
        </div>
        <div class="card-body">
            <login-service-component></login-service-component>
        </div>
    </div>
    <div class="card">
        <div class="card-header bg-white">
            <div class="card-title">
                <h5 class="font-weight-semibold"><i class="fas fa-globe-asia mr-2"></i>{{$t('Preferred Language')}}</h5>
                <div>{{$t('This is the language you will see when you logged in to your stores')}}</div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <preferred-language-component></preferred-language-component>
                </div>

            </div>

        </div>
    </div>
    <!-- <div id="ModalEditAccountInfo" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="bg-light border-bottom-0 modal-header">
                        <h6 class="modal-title"><i class="far fa-user-cog mr-2"></i>Edit Info</h6>
                    </div>
                    <div class="modal-body">
                        <modal-edit-account-info-component></modal-edit-account-info-component>
                    </div>
                </div>
            </div>
        </div>
        -->
        <div id="ModalChangeEmail" class="modal fade" data-backdrop="static" data-keyboard="false"   >
            <div class="modal-dialog" v-if="!showModalForgotPassword">
                <div class="modal-content">
                    <div class="bg-light border-bottom-0 modal-header">
                        <h5 class="modal-title">{{$t('Change Your Email ')}}</h5>
                        <button
                            type="button"
                            class="close"
                            ref="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <modal-change-email-component ref="ModalChangeEmailComp"></modal-change-email-component>
                    </div>
                </div>
            </div>
            <div v-else><ModalForgot /></div>
        </div>


        <div id="ModalChangePhone" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <div class="modal-dialog" v-if="!showModalForgotPassword">
                <div class="modal-content">
                    <div class="bg-light border-bottom-0 modal-header">
                        <h5 class="modal-title">{{$t('Change Your Phone')}}</h5>
                        <button
                            type="button"
                            class="close"
                            ref="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <modal-change-phone-component ref="ModalChangePhone"></modal-change-phone-component>
                    </div>
                </div>
            </div>
            <div v-else><ModalForgot /></div>
        </div>

        <!-- Modal Verification OTP -->
        <div id="ModalVerifiPhone" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <modal-verifi-phone ref="ModalVerifiPhone"></modal-verifi-phone>
        </div>

        <!-- Modal Verification Email -->
        <div id="ModalVerifiEmail" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <modal-verifi-email ref="ModalVerifiEmail"></modal-verifi-email>
        </div>
</div>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service'
//components
import AlertComponent from '../Alert';
import AccountDetailsComponent from './AccountDetails';
import LoginServiceComponent from './LoginService';
import PreferredLanguageComponent from './PreferredLanguage';

import ModalEditAccountInfoComponent from './ModalEditAccountInfo';
import ModalChangeEmailComponent from './ModalChangeEmail';
import ModalChangePhoneComponent from './ModalChangePhone';
import { Axis } from 'echarts';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import { required } from "vuelidate/lib/validators";
import ModalForgot from './ModalForgot.vue';
import ModalVerifiPhone from './ModalVerifiPhone.vue';
import ModalVerifiEmail from './ModalVerifiEmail.vue';


export default {
    name: "modal_change_email",
    components: {
        PlaceholderContent,
        AlertComponent,
        AccountDetailsComponent,
        LoginServiceComponent,
        PreferredLanguageComponent,
        ModalEditAccountInfoComponent,
        ModalChangeEmailComponent,
        ModalChangePhoneComponent,
        ModalForgot,
        ModalVerifiPhone,
        ModalVerifiEmail
    },
    data() {
        return {
            showInfo : true,
            user: {
                first_name: '',
                last_name: '',
                image_profile: '',
                customer: {
                    address1: '',
                    address2: '',
                    sub_district: '',
                    district: '',
                    province: '',
                    zipcode: ''
                }
            },
            showModalForgotPassword: false,
            newPhone:'',
            showPhone:'',
            inputVerficationCode: '',
            showEmail:'',
            
        }
    },
    methods: {
        async getUser() {
            let data = await CentralApi.Auth.getUser()
            let fullname = data.data.data.first_name;
            let image_url = data.data.data.image_url;

            if (data.data.data.image_url === '') {
                image_url = require("@/assets/images/no-image-user.png");
            } else {
                image_url = data.data.data.image_url;
            }

            $('.dropdown-user span.pl-2').html(fullname);
            $('.vue-avatar--wrapper span').remove();
            $('.vue-avatar--wrapper').css('background-image', 'url(' + image_url + ')');
        },
        
        fetchData(data) {

            this.user.first_name = (data.first_name) ? data.first_name : '';
            this.user.last_name = (data.last_name) ? data.last_name : '';
            this.user.image_profile = data.image_profile;
            this.user.customer.address1 = (data.customer.address1) ? data.customer.address1 : '';
            this.user.customer.address2 = (data.customer.address2) ? data.customer.address2 : '';
            this.user.customer.sub_district = (data.customer.sub_district) ? data.customer.sub_district : '';
            this.user.customer.district = (data.customer.district) ? data.customer.district : '';
            this.user.customer.province = (data.customer.province) ? data.customer.province : '';
            this.user.customer.zipcode = (data.customer.zipcode) ? data.customer.zipcode : '';
            this.user.customer.country_id = (data.customer.country_id) ? data.customer.country_id : '1';
        },
        confirmSave(id) {
            let $this = this;
            this.$swal.fire({
                title: this.$t('Confirm Change Account Details?'),
                icon: 'question',
                iconColor: '#455A64',
                showCancelButton: true,
                confirmButtonText: '<i class="fas fa-check-circle mr-2"></i>'+this.$t('Confirm'),
                confirmButtonColor: "#1F88E5",
                cancelButtonText: this.$t('Cancel'),
                buttonsStyling: false,
                customClass: {
                    title:'h5',
                    html: 'body',
                    confirmButton: 'btn btn-primary mr-2',
                    cancelButton: 'btn btn-outline-normal'
                },
                focusConfirm: false,
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: function() {
                    const userForm = $this.$refs.accountDetails;
                    let image = '';
                    if($this.user.image_profile){
                        image = $this.user.image_profile.startsWith("data:image/") ? $this.user.image_profile : '';  //accept only  base64 
                    }
                    var params = {
                        file: image,
                        first_name: $this.user.first_name,
                        last_name: $this.user.last_name,
                        address1: userForm.user.customer.address1,
                        address2: userForm.address2,
                        sub_district: userForm.sub_district,
                        district: userForm.district,
                        province: userForm.province,
                        zipcode: userForm.zipcode,
                        country_id: userForm.country_id
                    };

                    var self = $this;

                    return new Promise((resolve, reject) => {
                        CentralApi.Auth.postUser(params).then(function(res) {

                            if(res.status == 403){
                                self.$toastr.e(this.$t('Please upload other image or contact the staff'),"<span class='icon-blocked'></span>"+ this.$t('Error'));
                                resolve();
                            }

                            self.getUser();
                            self.$toastr.s(self.$t("update information success"),"<span class='t-icon icon-checkmark3'></span>"+self.$t("Success"));
                            resolve();

                        }).catch((error) => {
                            console.log(error, 'catch');
                            self.$toastr.e(self.$t('Your picture is insecure. Please change a new one.'),"<span class='icon-blocked'></span>"+self.$t('Error'));
                            resolve();
                        })
                    });

                }
            }).then((result) => {
                if(result.isConfirmed) {}
            }).catch((error) => {
                console.log(error);
            })
        },

    },
    validations: {
        user: {
            first_name: {
                required,
            },
            last_name: {
                required,
            }
        },
        validationGroup: ['user.first_name', 'user.last_name']
    },
}
</script>




// WEBPACK FOOTER //
// src/components/central/account/profile/Index.vue